import React from 'react';
import DistanceToPolygonLine from './DistanceToPolygonLine/DistanceToPolygonLine';
import { distanceToPolygonInfoState } from '../../../../../app/redux/retrievers/retrievers';
import { useSelector } from 'react-redux';

const PolylineLayer = () => {
    const distanceToPolygonInfo = useSelector(distanceToPolygonInfoState);

    return (
        <>
            {distanceToPolygonInfo.polylineCoords && distanceToPolygonInfo.polylineCoords.length > 0 && (
                <DistanceToPolygonLine />
            )}
        </>
    );
};

export default PolylineLayer;
